import { render, staticRenderFns } from "./Lamedea.vue?vue&type=template&id=0dc36e2a"
import script from "./Lamedea.vue?vue&type=script&lang=js"
export * from "./Lamedea.vue?vue&type=script&lang=js"
import style0 from "./Lamedea.vue?vue&type=style&index=0&id=0dc36e2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports